import { autoinject, BindingEngine, customElement, computedFrom } from 'aurelia-framework';
import { ModelBase } from 'support/base_classes/model-base';
import { LocationsMapFilter } from 'api/locations-map';
import { LookupsService } from '../../services/lookups-service';

@autoinject
@customElement('locations-map-filter')
export class LocationsMapFilterCustomElement extends ModelBase<LocationsMapFilter> {
  constructor(bindingEngine: BindingEngine, private lookups: LookupsService) {
    super(bindingEngine);
  }

  usersLookupOptions = this.lookups.getUsersLookupOptions();

  @computedFrom('model.user')
  get userLabel() {
    return ['Search user / bp employee name', this.model.user?.mail, this.model.user?.phone].filter(l => l != null);
  }
}
